import React, { FC } from 'react';
import ReactDatePicker, { ReactDatePickerProps } from 'react-datepicker';
import { StyledInput } from '../Input';
import { EnumSize } from '../../constants/enums';
import Text from 'Components/Typography/Text';
import ru from 'date-fns/locale/ru';
import format from 'date-fns/format';
import parse from 'date-fns/parse';
import { FontSize } from '../../theme';
import { useField } from 'formik';
import Header from './Header';
import Popper from './Popper';
import { omit } from 'ramda';

const ACTUAL_DATE_FORMAT = 'yyyy-MM-dd';
const DISPLAY_DATE_FORMAT = 'dd.MM.yyyy';
const DEFAULT_POPPER_MODIFIERS = {
  offset: {
    enabled: true,
    offset: '0, 8px',
  },
  preventOverflow: {
    enabled: true,
    escapeWithReference: false,
    boundariesElement: 'viewport',
    padding: 8,
  },
};

interface IDatePickerProps extends Omit<ReactDatePickerProps, 'onChange' | 'onBlur'> {
  name: string;
  placeholder?: string;
  testId?: string;
}

const DatePicker: FC<IDatePickerProps> = ({ value, placeholder, name, testId, ...props }) => {
  // onChange почему-то не отрабатывает, поэтому пришлось закостылить решение с setValue и setTouched
  const [{ onBlur }, , { setValue, setTouched }] = useField(name);
  return (
    <ReactDatePicker
      locale={ru}
      selected={value ? parse(value, ACTUAL_DATE_FORMAT, new Date()) : undefined}
      dateFormat={DISPLAY_DATE_FORMAT}
      renderCustomHeader={props => <Header {...props} />}
      onChange={(val: Date) => {
        setTouched(true);
        setValue(format(val, ACTUAL_DATE_FORMAT));
      }}
      onBlur={onBlur}
      placeholderText={placeholder}
      popperPlacement="bottom-start"
      popperContainer={Popper}
      // если вынести модификаторы в константу, то тс начинает ругаться на несовместимость типов boundariesElement
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      popperModifiers={DEFAULT_POPPER_MODIFIERS}
      customInput={<StyledInput name={name} data-testid={testId} $sizeName={EnumSize.md} />}
      renderDayContents={day => <Text size={FontSize.xs}>{day}</Text>}
      //выбрасываем свойства onChange, onBlur и value чтобы не было конфликтов, но можно было извне кастомизировать дейтпикер
      {...omit(['onChange', 'onBlur', 'value'], props)}
    />
  );
};

export default DatePicker;
